import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {UserComponent} from '@layouts/user/user.component';
import {SchoolModule} from '@pages/layout/school/school.module';
import {ProfileModule} from '@pages/layout/profile/profile.module';
import {PageGuardGuard} from '@app/page-guard.guard';
import {LandingModule} from '@pages/landing/landing.module';


const routes: Routes = [
  {
    path: 'auth',
    loadChildren: './pages/auth/auth.module#AuthModule'
  },
  {
    path: 'landing',
    loadChildren: './pages/landing/landing.module#LandingModule'
  },
  {
    path: '',
    component: UserComponent,
    canActivateChild: [PageGuardGuard],
    children: [
      {
        path: 'home',
        loadChildren: './pages/layout/home/home.module#HomeModule'
      },
      {
        path: 'profile',
        loadChildren: './pages/layout/profile/profile.module#ProfileModule'
      },
      {
        path: 'school',
        loadChildren: './pages/layout/school/school.module#SchoolModule'
      },
      {
        path: 'trial-school',
        loadChildren: './pages/layout/school/school.module#SchoolModule'
      },
      {
        path: 'trial',
        loadChildren: './pages/layout/trial/trial.module#TrialModule'
      },
      {
        path: 'not-joined',
        loadChildren: './pages/layout/school/school.module#SchoolModule'
      },
      {
        path: 'admins',
        loadChildren: './pages/layout/admin/admin.module#AdminModule'
      },
      {
        path: 'dashboard',
        loadChildren: './pages/layout/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'conversion',
        loadChildren: './pages/layout/conversion/conversion.module#ConversionModule'
      },
      {
        path: 'program',
        loadChildren: './pages/layout/program/program.module#ProgramModule'
      },
      {
        path: 'students',
        loadChildren: './pages/layout/student/student.module#StudentModule'
      },
      {
        path: 'teachers',
        loadChildren: './pages/layout/teacher/teacher.module#TeacherModule'
      },
      {
        path: 'subscriptions',
        loadChildren: './pages/layout/subscription/subscription.module#SubscriptionModule',
      },
      {
        path: 'curriculums',
        loadChildren: './pages/layout/curriculum/curriculum.module#CurriculumModule'
      },
      {
        path: 'payments',
        loadChildren: './pages/layout/payments/payments.module#PaymentsModule'
      },
      {
        path: 'platform-stripe-accounts',
        loadChildren: './pages/layout/platform-stripe-accounts/platform-stripe-accounts.module#PlatformStripeAccountsModule'
      },
      {
        path: 'platform-billing-preview',
        loadChildren: './pages/layout/platform-billing-preview/platform-billing-preview.module#PlatformBillingPreviewModule'
      },
      {
        path: 'project-management',
        loadChildren: './pages/layout/project-management/project-management.module#ProjectManagementModule'
      },
      {
        path: 'school-profile',
        loadChildren: './pages/layout/school-profile/school-profile.module#SchoolProfileModule'
      },
      {
        path: 'super-admin-students',
        loadChildren: './pages/layout/super-admin-student/super-admin-student.module#SuperAdminStudentModule'
      },
      {
        path: 'my-kool-cat-subscription',
        loadChildren: './pages/layout/my-kool-cat-subscription/my-kool-cat-subscription.module#MyKoolCatSubscriptionModule'
      },
      {
        path: 'reports',
        loadChildren: './pages/layout/reports/reports.module#ReportsModule'
      },
      {
        path: 'expiring',
        loadChildren: './pages/layout/expiring/expiring.module#ExpiringModule'
      },
      {
        path: 'attendance',
        loadChildren: './pages/layout/attendance/attendance.module#AttendanceModule'
      },
      {
        path: 'permissions',
        loadChildren: './pages/layout/permissions/permissions.module#PermissionsModule'
      },
      {
        path: 'messages',
        loadChildren: './pages/layout/messages/messages.module#MessagesModule'
      },
      {
        path: '**',
        redirectTo: '/auth/login'
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  providers: [PageGuardGuard],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }
